export const INSTAGRAM = "https://www.instagram.com/savisojourns/";
const HANDLE = "@savisojourns";

const Glyph = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" />
  </svg>
);

// Header: a single glyph beside the register link.
export const FollowGlyph = ({ testid = "sojourns-header-instagram" }) => (
  <a href={INSTAGRAM} className="sj-header-ig" target="_blank" rel="noopener noreferrer" aria-label={`${HANDLE} on Instagram`} data-testid={testid}>
    <Glyph />
  </a>
);

// Footer line: the handle in mono, as the other contact links.
export const FollowLink = ({ testid = "sojourns-contact-instagram" }) => (
  <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" data-testid={testid}>{HANDLE}</a>
);

// The block: a sentence and a pill. `quiet` shrinks it for success states.
export const Follow = ({ quiet = false, line, testid = "sojourns-follow" }) => (
  <div className={`sj-follow ${quiet ? "quiet" : ""}`} data-testid={testid}>
    {!quiet && <p className="sj-label">Instagram</p>}
    <p className="sj-follow-line">{line || "Most of what there is to know about the month will appear on Instagram first. Keep an eye on it."}</p>
    <a href={INSTAGRAM} className="sj-follow-btn" target="_blank" rel="noopener noreferrer" data-testid={`${testid}-link`}>
      <Glyph size={14} />
      <span>Follow {HANDLE}</span>
    </a>
  </div>
);
